// extracted by mini-css-extract-plugin
export default {"rect":"Rect_rect__KZsRA"};